import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const CustomIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <g id="Layer_2" data-name="Layer 2">
   <path d="M15.26,5.53h-6.14c-.28-.97-1.3-1.53-2.27-1.24-.6.18-1.07.64-1.24,1.24h-.87c-.29,0-.53.24-.53.53s.24.53.53.53h.87c.28.97,1.3,1.53,2.27,1.24.6-.18,1.07-.64,1.24-1.24h6.14c.29,0,.53-.24.53-.53s-.24-.53-.53-.53ZM7.37,6.84c-.44,0-.79-.35-.79-.79s.35-.79.79-.79.79.35.79.79-.35.79-.79.79Z" />
   <path d="M15.26,13.42h-6.14c-.28-.97-1.3-1.53-2.27-1.24-.6.18-1.07.64-1.24,1.24h-.87c-.29,0-.53.24-.53.53s.24.53.53.53h.87c.28.97,1.3,1.53,2.27,1.24.6-.18,1.07-.64,1.24-1.24h6.14c.29,0,.53-.24.53-.53s-.24-.53-.53-.53ZM7.37,14.74c-.44,0-.79-.35-.79-.79s.35-.79.79-.79.79.35.79.79-.35.79-.79.79h0Z" />
   <path d="M15.26,9.47h-.88c-.28-.97-1.3-1.53-2.27-1.24-.6.18-1.07.64-1.24,1.24h-6.14c-.29,0-.53.24-.53.53s.24.53.53.53h6.14c.28.97,1.3,1.53,2.27,1.24.6-.18,1.07-.64,1.24-1.24h.88c.29,0,.53-.24.53-.53s-.24-.53-.53-.53ZM12.63,10.79c-.44,0-.79-.35-.79-.79s.35-.79.79-.79.79.35.79.79-.35.79-.79.79Z" />
   <path d="M10,0C4.48,0,0,4.48,0,10s4.48,10,10,10,10-4.48,10-10C19.99,4.48,15.52,0,10,0ZM10,18.95c-4.94,0-8.95-4.01-8.95-8.95S5.06,1.05,10,1.05s8.95,4.01,8.95,8.95c0,4.94-4.01,8.94-8.95,8.95Z" />
  </g>
 </svg>,
 "Custom"
);
